import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'

//var dateFormat = require('dateformat');


const RenderWpForm = () => {

const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
const resturl=sessionStorage.getItem("RESTURL");	
const scansurl=sessionStorage.getItem("SCANSURL");	


//var boolFetchingSads=false;

const navigate = useNavigate();


const [dowait, setDowait] = useState({show:false});
const [dlwait, setDlwait] = useState({show:false});
const [latedlwait, setLatedlwait] = useState({show:false});

const [wptapp, setWptapp] = useState({});
const [axiofl, setAxiofl] = useState({selectedFile: null});
const [progress, setProgress] = useState({
perct:null
});

const location = useLocation();


useEffect(() => {
	
if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if	
	
document.title =   "APS Manage Documents";	
//test app BMA01ne
if (location.state!=null)
	if (location.state.wptapp)
		setWptapp(location.state.wptapp);

 },[]);

async function doFileUpload () {

 
 const FormData = require('form-data'); // npm install --save form-data

const form = new FormData();
const filename='lbrclrappeal.pdf';
const lbrclrappealfile=new File([axiofl.selectedFile], filename);

form.append('WPT_APP_ID', wptapp.WPT_APP_ID);
form.append('REF_NUM', wptapp.REF_NUM);
form.append('USERNAME', sessionStorage.getItem("USERNAME"));
form.append('filename', filename);
form.append('file', lbrclrappealfile, lbrclrappealfile.name);//
//form.append('filename', axiofl.selectedFile.name);


setDowait({show:true});
//importingwptapp=true;
const request_config = {
    onUploadProgress: data => {
      //Set the progress value to show the progress bard
      setProgress({perct:Math.round((100 * data.loaded) / data.total)});
    },
};
await axios.post(scansurl+'rarscans/uploadlbrclrappeal', form, request_config)
.then(res => afterDoFileUpload(res.data))
.catch(error => { 
		setDowait({show:false});
         showsnackbar(error+"<br/>please try logout and login again");
     });//end catch
	 
}//end function

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


function afterDoFileUpload(res){
	console.log('afterDoFileUpload res: '+JSON.stringify(res));
	setDowait({show:false});
	setAxiofl({ selectedFile: null });
	setWptapp((prev)=>{
		return {...prev, TC_LC_APPEAL_DATE:res[0].TC_LC_APPEAL_DATE}
	})
	document.getElementById('fileinput').value='';
	showsnackbar("done!");
//importingwptapp=false;
//setDowait({show:false})
//navSubmitwpform.current?.click();
}//end function

	
function onFileChange(event) {

setAxiofl({ selectedFile: null });

if (event.target.files.length>1){
	document.getElementById("fileinput").value='';
	showsnackbar("upload only one file please");
	return;
	}
else if (event.target.files.length==0){
	document.getElementById("fileinput").value='';
	return;
	}
	
	
const fileName=event.target.files[0].name;
var fileExtension = "";
if (fileName.lastIndexOf(".") > 0) 
	fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);
//,.jpg,.jpeg
const lsExtension="pdf";
if (!(", "+lsExtension).includes(", "+fileExtension)){
	document.getElementById("fileinput").value='';
	showsnackbar("error: the uploaded file must have one of these extensions: "+lsExtension);
	return;
	}//end if	

if (event.target.files.length==1){
	if (document.getElementById('btnuploadlbrclrappeal'))
		document.getElementById('btnuploadlbrclrappeal').style.visibility='visible';
	
	// Update the state
	setAxiofl({ selectedFile: event.target.files[0] });
	}//end if

}//end function


async function openScans (e, filename) {
e.preventDefault();

const relFilepath=wptapp.REF_NUM+"/"+filename;
const params={
	filepath:relFilepath
	, TBL: "WPT"
	, WPT_APP_ID: wptapp.WPT_APP_ID
	, AD_USER:sessionStorage.getItem("AD_USER")
	, FILENAME: filename
	, FLAG_DL: 1
	};
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

	if (filename=="lbrclrappeal.pdf")
		setLatedlwait({show:true});
	else
		setDlwait({show:true});

  fetch(scansurl+'rarwpform/getwptappfile',requestOptions)
      .then(res => afteropenScans(res, filename))
      .catch(err => console.log(err));


}//end func

async function afteropenScans(res, filename){
const downloadFilename = wptapp.REF_NUM+"_"+filename;
const blob = await res.blob();
//console.log('blob.length: '+blob.length);
const data = window.URL.createObjectURL(new Blob([blob]));

const link = document.createElement("a");
link.href = data;
link.setAttribute("download", downloadFilename);
document.body.appendChild(link);
link.click();
//link.parentNode!.removeChild(link);	
link.parentNode?.removeChild(link);	


if (filename=="lbrclrappeal.pdf")
	setLatedlwait({show:false});
else
	setDlwait({show:false});


}//end func


  return (
    <>
	<h2  align='center' >you can upload response to labour clearance letter here</h2>
	<p style={{color:"brown"}} align="center" >
	Deferred labour clearance example: upload missing documents and/or letter appealing deferred labour clearance
	<br/>Denied labour clearance example: upload a letter from the Minister's office approving denied labour clearance
	</p>

	<table align='center'>
	<tbody>
	
	<tr>
	<td align='right' >Applicantion Ref: </td>
	<td align='left' >{wptapp.REF_NUM}</td>
	</tr>
	<tr>
	<td align='right' >Date Submitted: </td>
	<td align='left' >{wptapp.CHR_SUBMITTED_TO_CSC}</td>
	</tr>	
	<tr>
	<td align='right' >Submitted By: </td>
	<td align='left' >{wptapp.EMAIL_TO}</td>
	</tr>	
	
	<tr>
	<td align='right' >Employer's Name: </td>
	<td align='left' >{wptapp.MPR_NAME}</td>
	</tr>
	<tr>
	<td align='right' >Applicant's Name: </td>
	<td align='left' >{wptapp.MPE_FIRST_NAME+" "+wptapp.MPE_LAST_NAME}</td>
	</tr>
	<tr>
	<td align='right' >Applicant's Immig. Ref: </td>
	<td align='left' >{wptapp.IMG_REF}</td>
	</tr>
	<tr>
	<td align='right' >Job Title: </td>
	<td align='left' >{wptapp.MPE_OCCUPATION}</td>
	</tr>
	<tr>
	<td align='right' >Application Status: </td>
	<td align='left' >{wptapp.STATUS}</td>
	</tr>
	<tr>
	<td align='right' >Appeal letter upload Date: </td>
	<td align='left' >{wptapp.TC_LC_APPEAL_DATE??""}</td>
	</tr>

	<tr>
	<td align='right' ><a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/wptform", {state:{WPT_APP_ID:wptapp.WPT_APP_ID,SCTN:"J"}});  }}  ><img src="img/return.png" border="0" /> return to application</a></td>

	<td align='left' style={{paddingLeft:"18px"}} >
		{<input type="file" id="fileinput" accept=".pdf" onChange={(e)=>{onFileChange(e);}}   />}
		&nbsp;&nbsp;
		
		
		{dowait.show==true && <><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</>}
		{
		dowait.show==false && axiofl.selectedFile!=null && 
		<button onClick={doFileUpload} className='button' id='btnuploadlbrclrappeal' >upload file</button>
		}		
			
	</td>
	</tr>
	<tr>
		<td align='center' colSpan='2' >&nbsp;</td>
	</tr>
		{
		wptapp.LC_APPEAL_PDF_SIZE>0 && 	
		<tr>
			<td align='center' colSpan='2' style={{paddingBottom:"9px"}} >
			{latedlwait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
			{!latedlwait.show && <a href="#" onClick={(e)=>{openScans(e,"lbrclrappeal.pdf");}} className="nodecor" ><img src='img/pdf.gif' border='0' /> click here to see appeal letter</a>}
			</td>
		</tr>
		}
	<tr>
	<td align='center' colSpan='2' >
		{wptapp.REF_NUM!=undefined && <>
		<img src={resturl+"rarwpform/getwptappfoto?path="+wptapp.REF_NUM+"/foto.png"} border='0' height="150" />
		<br/>close-up head shot
		</>
		}
		</td>
	</tr>
	
	</tbody>
	</table>
	



<div id="snackbar">&nbsp;</div>
    </>
  );
  


};


export default RenderWpForm;